import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';
import Tag from '@components/Tag';
import classNames from 'classnames/bind';

import styles from '../EdiDataGrid.module.css';
import cellStyles from '../../RenderCell.module.css';
const stylesContext = classNames.bind(cellStyles);

export default function EdiTypeCell({ row }: { row: LoadTender }) {
	return (
		<>
			<span
				className={stylesContext({
					['stacked-text-cell-primary-slot']: true,
					bold: true
				})}
				title={row.status}
			>
				{row.isExport ? 'Export' : 'Import'}
			</span>

			<div className={styles['edi-leg-status-toolbar']}>
				<Tag
					text='LIVE'
					tagStyle={row.isLive ? 'live' : 'disabled'}
					dense
				/>
				<Tag
					text='HAZ'
					tagStyle={row.isHaz ? 'haz' : 'disabled'}
					dense
				/>
				<Tag
					text='WGT'
					tagStyle={row.isOverweight ? 'wgt' : 'disabled'}
					dense
				/>
			</div>
		</>
	);
}
